import React, { useEffect, useState } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../../redux/actions/index';
import { useForm } from 'react-hook-form';
import { Button } from '@chakra-ui/react';
import _ from 'lodash';

export default function EditCommonWork() {
  const { register, handleSubmit, errors } = useForm();
  const { id, id2 } = useParams();
  const history = useHistory();
  const department = useSelector((state) => state.department);
  const commonWork = useSelector((state) => state.commonWork);
  const [commonworkSelect, setCommonworkSelect] = useState([]);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actions.departmentAll());
    dispatch(actions.positionAll());
    return () => {};
  }, []);

  const genDepartmentOption = () =>
    _.map(department, (_department) => {
      if (_department.department_id == id) {
        return (
          <option
            key={_department.department_id}
            selected
            value={_department.department_id}
          >
            {_department.department_name}
          </option>
        );
      } else {
        return (
          <option
            key={_department.department_id}
            value={_department.department_id}
          >
            {_department.department_name}
          </option>
        );
      }
    });
  const onSubmit = (data, e) => {
    dispatch(actions.commonWorkEdit(commonworkSelect[1], data)).then(() => {
      console.log('แก้ไขงานทั่วไปสำเร็จ');
      dispatch(actions.commonWorkAll());
      history.push('/hrms/department/details/' + id);
    });
  };

  const findCommonWork = () => {
    const commonWorkFilter = _.find(commonWork, (_commonWork) => {
      if (_commonWork.work_id == id2) return _commonWork;
    });

    if (commonWorkFilter !== undefined) {
      commonworkSelect[0] = commonWorkFilter.work_name;
      commonworkSelect[1] = commonWorkFilter.work_id;
    }
  };

  return (
    <div>
      <h2 className="text-gray-800 text-xl font-semibold py-1">แก้ไขตำแหน่ง</h2>
      <div className="flex justify-between py-6">
        <Link to={'/hrms/department/details/' + id}>
          <Button variant="outline">กลับ</Button>
        </Link>
      </div>
      {findCommonWork()}
      <div className="p-4">
        <div className="flex content-center items-center justify-center h-full">
          <div className="w-full lg:w-6/12 px-4">
            {' '}
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="relative w-full mb-3">
                <label
                  className="block uppercase text-gray-700 text-xs font-bold mb-2"
                  htmlFor="grid-password"
                >
                  ชื่องาน
                </label>
                <input
                  name="work_name"
                  type="text"
                  required
                  ref={register}
                  defaultValue={commonworkSelect[0]}
                  className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                  placeholder="ชื่องาน"
                />
              </div>

              <div className="relative w-full mb-3">
                <label
                  className="block uppercase text-gray-700 text-xs font-bold mb-2"
                  htmlFor="grid-password"
                >
                  แผนก
                </label>
                <select
                  name="department_id"
                  required
                  ref={register}
                  className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                >
                  {genDepartmentOption()}
                </select>
              </div>

              <div className="relative w-full mb-3">
                <div className="text-center mt-6">
                  <Button isFullWidth colorScheme="yellow" type="submit">
                    แก้ไข
                  </Button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
